import {reverse} from '@utils/helper';

const DELIVERY_STATUS = {
  DELIVERY: {
    id: 1,
    text: '投放中',
  },
  NOT_START: {
    id: 2,
    text: '未开始',
  },
  OVER: {
    id: 3,
    text: '已结束',
  },
};
const REVERSE_DELIVERY_STATUS = reverse(DELIVERY_STATUS);

export { DELIVERY_STATUS, REVERSE_DELIVERY_STATUS };
